"use client";

import React from "react";
import styles from "./modular-permissions.module.scss";
import useSwitchToBless from "@/features/mod-perms/hooks/useSwitchToBless.hook";
import { useAccount } from "wagmi";
import { motion } from "framer-motion";
import AddPermissionBlock from "@/features/mod-perms/components/permission-blocks/add-permission-block";

const CreateSocialPerm = () => {
  useSwitchToBless();
  const accountStatus = useAccount();

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className={styles.createPermsWrapper}
    >
      <div className={styles.interfaceContainer}>
        <AddPermissionBlock accountStatus={accountStatus} />
      </div>
    </motion.div>
  );
};

export default CreateSocialPerm;
